import type {
  PdMeasurementResult,
  ShMeasurementResult,
} from '@ca/optical-measure/flow'
import { createContext, useContext } from 'react'

export type ActiveMeasurement =
  | {
      type: 'pd'
      onComplete: (result: PdMeasurementResult) => void
    }
  | {
      type: 'sh'
      vboxMm?: number
      onComplete: (result: ShMeasurementResult) => void
    }

type MeasurementContextValue = {
  open: (measurement: ActiveMeasurement) => void
}

export const MeasurementContext = createContext<MeasurementContextValue | null>(
  null
)

export const useMeasurementLauncher = () => {
  const context = useContext(MeasurementContext)
  if (!context) {
    throw new Error('useMeasurementLauncher requires MeasurementProvider')
  }
  return context
}
